import React, {useEffect, useState} from 'react';
import {getCommissionsPayments} from "../../../../services/Profile";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";
import {useTranslation} from "react-i18next";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableFooter from "@mui/material/TableFooter";
import {currencyFormat} from "../../../../utils/masks";
import DivDiagonal from "../../../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
} from "../../../Trading/styles";
import {
    StrategyPageHeader,
    StrategyWideCardColumn,
    StrategyProductCard,
    StrategyTableContainer,
    StrategyTableWrapper,
    StrategyPaginationInfo,
    StrategyPaginationButton,
    StrategyLoadingButton,
    StrategyEmptyState,
} from "../../../Strategy/styles";

export default function PaymentCommission() {
  const [loadingList, setLoadingList] = useState(false);
  const { t } = useTranslation();
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(1);

  useEffect( () => {
    setLoadingList(true);
    getCommissionsPayments({
      page: page,
      per_page: 25,
    }).then((data) => {
      if (!data || data === '') {
        return;
      }

      setPayments(data.data);
    }).finally(() => {
      setLoadingList(false);
    });

    return function cleanup() {
      setPayments([]);
    };
  }, [page]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    const rowCount = payments?.data?.length || 0;

    return (
        <TradingWrapper>
            <DivDiagonal/>
            <ContentArea>
                <StrategyPageHeader>
                    <h1>
                        <i className="fa fa-receipt" aria-hidden="true"/>
                        {' '}{t('admin_commission_payments_title')}{' '}
                        <span className="badge">{rowCount}</span>
                    </h1>
                </StrategyPageHeader>

                <StrategyWideCardColumn>
                    <StrategyProductCard>
                        <StrategyTableWrapper>
                            {loadingList ? (
                                <StrategyLoadingButton
                                    className="btn btn-primary text-capitalize font-weight-bold"
                                    loading={loadingList}
                                    type="button"
                                >
                                    {t('loading')}
                                </StrategyLoadingButton>
                            ) : (
                                <>
                                    {payments && payments.data && payments.data.length ? (
                                        <StrategyTableContainer>
                                            <Table aria-label={t('admin_commission_payments_title')}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>{t('admin_commission_payments_col_date')}</TableCell>
                                                        <TableCell>{t('admin_commission_payments_col_affiliate')}</TableCell>
                                                        <TableCell>{t('admin_commission_payments_col_value')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {payments.data.map((payment) => (
                                                        <TableRow key={payment.id}>
                                                            <TableCell>
                                                                {new Date(payment.created.date).toLocaleDateString()}
                                                            </TableCell>
                                                            <TableCell>
                                                                {payment.affiliateUser ? payment.affiliateUser.email : ''}
                                                                <br/>
                                                                <small style={{ color: 'rgba(255,255,255,0.45)' }}>
                                                                    ID: {payment.affiliateUser ? (payment.affiliateUser.id).split('-')[0] : ''}
                                                                    <br/>
                                                                    {t('admin_commissions_affiliate_id')}: {payment.affiliateUser ? (payment.affiliateUser.affiliateID).split('-')[0] : ''}
                                                                </small>
                                                            </TableCell>
                                                            <TableCell>
                                                                {currencyFormat(parseFloat(payment.value ? payment.value : 0), 'R$')}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                                <TableFooter>
                                                    <TableRow>
                                                        <TableCell colSpan={3}>
                                                            <div style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                flexWrap: 'wrap',
                                                                gap: 12,
                                                            }}>
                                                                <StrategyPaginationInfo>
                                                                    {t('table_pagination_text', {
                                                                        page,
                                                                        totalPage: payments.total_page + 1,
                                                                    })}
                                                                </StrategyPaginationInfo>
                                                                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                                                    <StrategyPaginationButton
                                                                        type="button"
                                                                        onClick={() => setPage(page - 1)}
                                                                        disabled={page <= 1}
                                                                    >
                                                                        <IoIosArrowBack/> {t('table_pagination_back')}
                                                                    </StrategyPaginationButton>
                                                                    <StrategyPaginationButton
                                                                        type="button"
                                                                        onClick={() => setPage(page + 1)}
                                                                        disabled={!payments.next_page}
                                                                    >
                                                                        {t('table_pagination_next')} <IoIosArrowForward/>
                                                                    </StrategyPaginationButton>
                                                                </div>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>
                                        </StrategyTableContainer>
                                    ) : (
                                        <StrategyEmptyState>
                                            <i className="fa fa-receipt" aria-hidden="true"/>
                                            <p>{t('admin_commission_payments_empty_title')}</p>
                                            <span>{t('admin_commission_payments_empty_subtitle')}</span>
                                        </StrategyEmptyState>
                                    )}
                                </>
                            )}
                        </StrategyTableWrapper>
                    </StrategyProductCard>
                </StrategyWideCardColumn>
            </ContentArea>
        </TradingWrapper>
    );
}
